type ShareContent = {
  message?: string;
  url?: string;
  title?: string;
};

export type ShareResult = 'shared' | 'copied';

export async function shareContent(content: ShareContent): Promise<ShareResult> {
  const payload = {
    title: content.title ?? 'Clubhouse profile',
    text: content.message,
    url: content.url,
  };

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share(payload);
      return 'shared';
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return 'shared';
      }
      throw error;
    }
  }

  const message = [content.title, content.message, content.url].filter(Boolean).join('\n');
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(message);
    return 'copied';
  }

  throw new Error('Sharing is not supported in this browser.');
}
